var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.breadcrumbs},[_c('div',{class:_vm.$style.path},[(_vm.activeItem)?_c('span',[_c('strong',[_vm._v(_vm._s(_vm.$t(_vm.activeItem, '')))])]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }